import 'whatwg-fetch';
import './polyfills';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import PlanYourVisitApp from './components/PlanYourVisitApp';
import configureStore from './store';


export function init(el, options) {
  if (typeof el === 'string') {
    el = document.querySelector(el);
  }

  const store = configureStore();

  render(
    <Provider store={store}><PlanYourVisitApp onSuccess={(options || {}).onSuccess} /></Provider>,
    el
  );
}



// WEBPACK FOOTER //
// ./src/app.js